export class MemoryOutputStream {
    onClose;
    content = "";
    constructor(onClose = null) {
        this.onClose = onClose;
    }
    write(chunk) {
        this.content += chunk;
        return Promise.resolve();
    }
    getContent() {
        return this.content;
    }
    async close() {
        if (this.onClose === null) {
            return;
        }
        this.onClose(this);
    }
}
//# sourceMappingURL=memory-output-stream.js.map